import { useParams } from 'react-router-dom'
import CurrencyForm from './CurrencyForm'

const View = () => {
    const params = useParams()

    return (
        <CurrencyForm
            id={parseInt(params.currencyId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Currency updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update currency',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating currency...',
                },
            }}
        />
    )
}

export default View
